package com.iptvplayer.web.ui.screen

import androidx.compose.runtime.*
import com.iptvplayer.shared.domain.model.IptvSource
import com.iptvplayer.shared.presentation.viewmodel.SourceViewModel
import com.iptvplayer.web.ui.*
import org.jetbrains.compose.web.css.*
import org.jetbrains.compose.web.dom.*

@Composable
fun SourcesScreen(vm: SourceViewModel, onBack: () -> Unit) {
    val state by vm.state.collectAsState()
    var tab by remember { mutableStateOf("xtream") }
    var editingId by remember { mutableStateOf<String?>(null) }
    var name by remember { mutableStateOf("") }
    var url by remember { mutableStateOf("") }
    var server by remember { mutableStateOf("") }
    var user by remember { mutableStateOf("") }
    var pass by remember { mutableStateOf("") }

    fun reset() { editingId = null; name = ""; url = ""; server = ""; user = ""; pass = "" }
    fun startEdit(src: IptvSource) {
        editingId = src.id; name = src.name
        when (src) {
            is IptvSource.M3USource -> { tab = "m3u"; url = src.url; server = ""; user = ""; pass = "" }
            is IptvSource.XtreamSource -> { tab = "xtream"; server = src.serverUrl; user = src.username; pass = src.password; url = "" }
        }
    }

    PageContainer {
        Div(attrs = { style { display(DisplayStyle.Flex); alignItems(AlignItems.Center); property("gap", "12px"); property("margin-bottom", "8px") } }) {
            GhostButton("← Back") { onBack() }
            H2(attrs = { style { property("margin", "0") } }) { Text("IPTV Sources") }
        }
        ErrorText(state.error)

        Div(attrs = { style { cardStyle(); property("padding", "18px"); property("margin-bottom", "10px") } }) {
            Div(attrs = { style { property("font-weight", "700"); property("margin-bottom", "14px") } }) {
                Text(if (editingId == null) "Add a source" else "Edit source")
            }
            if (editingId == null) {
                Div(attrs = { style { display(DisplayStyle.Flex); property("gap", "8px"); property("margin-bottom", "16px") } }) {
                    Chip("Xtream Codes", tab == "xtream") { tab = "xtream" }
                    Chip("M3U URL", tab == "m3u") { tab = "m3u" }
                }
            }
            Field("Name", name, "My provider") { name = it }
            if (tab == "xtream") {
                Field("Server URL", server, "http://host:port") { server = it }
                Field("Username", user, "username") { user = it }
                Field("Password", pass, "password", password = true) { pass = it }
            } else {
                Field("M3U URL", url, "http://host/playlist.m3u") { url = it }
            }

            val valid = if (tab == "xtream") name.isNotBlank() && server.isNotBlank() && user.isNotBlank() && pass.isNotBlank()
            else name.isNotBlank() && url.isNotBlank()

            Div(attrs = { style { display(DisplayStyle.Flex); property("gap", "10px"); property("align-items", "center") } }) {
                PrimaryButton(
                    text = if (editingId != null) "Save changes" else if (tab == "xtream") "Add Xtream source" else "Add M3U source",
                    enabled = valid && !state.isLoading,
                    fullWidth = false,
                ) {
                    val id = editingId
                    if (id != null) {
                        if (tab == "xtream") vm.updateXtreamSource(id, name.trim(), server.trim(), user.trim(), pass)
                        else vm.updateM3USource(id, name.trim(), url.trim())
                    } else {
                        if (tab == "xtream") vm.addXtreamSource(name.trim(), server.trim(), user.trim(), pass)
                        else vm.addM3USource(name.trim(), url.trim())
                    }
                    reset()
                }
                if (editingId != null) GhostButton("Cancel") { reset() }
            }
        }

        SectionTitle("Your sources")
        if (state.isLoading && state.sources.isEmpty()) {
            Spinner()
        } else if (state.sources.isEmpty()) {
            EmptyState("No sources yet. Add one above to load channels and movies.")
        } else {
            state.sources.forEach { src ->
                val subtitle = when (src) {
                    is IptvSource.M3USource -> src.url
                    is IptvSource.XtreamSource -> "${src.serverUrl} · ${src.username}"
                }
                RowItem(src.name, null, subtitle, onClick = { startEdit(src) }) {
                    GhostButton("Edit") { startEdit(src) }
                    GhostButton("Remove") { vm.removeSource(src.id); if (editingId == src.id) reset() }
                }
            }
        }
    }
}
